<template>
  <aside class="menu is-unselectable">
    <template v-for="category in Object.keys(computedMenu)">
      <p class="menu-label" :key="category">{{ category }}</p>
      <ul class="menu-list" :key="`${category}-ul`">
        <li v-for="item in Object.keys(computedMenu[category])" :key="item">
          <a
            @click="
              typeof computedMenu[category][item] === 'string' &&
                clickMenuItem(computedMenu[category][item])
            "
            :class="{
              'is-active': computedMenu[category][item] === $route.name,
              'is-header': typeof computedMenu[category][item] === 'object'
            }"
            >{{ item }}</a
          >
          <ul v-if="typeof computedMenu[category][item] === 'object'">
            <li
              v-for="subitem in Object.keys(computedMenu[category][item])"
              :key="subitem"
            >
              <a
                @click="clickMenuItem(computedMenu[category][item][subitem])"
                :class="{
                  'is-active':
                    computedMenu[category][item][subitem] === $route.name
                }"
                >{{ subitem }}</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </template>
    <p class="menu-la">&nbsp;</p>
    <ul class="menu-list">
      <li class="action">
        <a class="button is-danger" @click="$emit('sign-out')">
          <icon name="fa-sign-out-alt" />
          <span>Wyloguj się</span>
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>
import get from "lodash.get";
import { Icon } from "%helpers";
import P from "%const/permissions";

const Permission = Object.values(P)
  .flatMap(p => Object.keys(p))
  .reduce((acc, curr) => {
    acc[curr] = curr;
    return acc;
  }, {});

function parse(object, test = () => true) {
  if (object.route) {
    return test(object) ? object.route : undefined;
  }

  const obj = {};
  for (const item in object) {
    const parsed = parse(object[item], test);
    if (parsed && Object.entries(parsed).length > 0) {
      obj[item] = parsed;
    }
  }

  return obj;
}

export default {
  name: "admin-menu",

  components: {
    Icon
  },

  data() {
    return {
      menu: {
        "Strona główna": {
          Telewizja: {
            "Oferta TV": {
              route: "admin:tv-offer",
              permissions: [Permission.CREATE_TEMPLATE]
            },
            Pakiety: {
              route: "admin:tv-pricing",
              permissions: [Permission.CREATE_TEMPLATE]
            }
          },
          Internet: {
            "Oferta Internetu": {
              route: "admin:internet-offer",
              permissions: [Permission.CREATE_TEMPLATE]
            },
            Pakiety: {
              route: "admin:internet-pricing",
              permissions: [Permission.CREATE_TEMPLATE]
            }
          },
          Kontakt: {
            "Biura OTvK": {
              route: "admin:offices",
              permissions: [Permission.CREATE_TEMPLATE]
            },
            "Kontakty awaryne": {
              route: "admin:breakdown",
              permissions: [Permission.CREATE_TEMPLATE]
            }
          }
        },
        "Panel użytkownika": {
          Ogłoszenia: {
            route: "admin:messages",
            permissions: [
              Permission.CREATE_MESSAGE,
              Permission.UPDATE_MESSAGE,
              Permission.DELETE_MESSAGE
            ]
          },
          Program: {
            route: "admin:program",
            permissions: [
              Permission.CREATE_PROGRAM_BLOCK,
              Permission.UPDATE_PROGRAM_BLOCK,
              Permission.DELET_PROGRAM_BLOCK,
              Permission.CREATE_PROGRAM_ITEM,
              Permission.UPDATE_PROGRAM_ITEM,
              Permission.DELETE_PROGRAM_ITEM
            ]
          },
          "Materiały TV": {
            Tagi: {
              route: "admin:videotags",
              permissions: [
                Permission.CREATE_TAG,
                Permission.UPDATE_TAG,
                Permission.DELETE_TAG
              ]
            },
            Filmy: {
              route: "admin:videos",
              permissions: [
                Permission.READ_STATISTICS,
                Permission.CREATE_VIDEO,
                Permission.UPDATE_VIDEO,
                Permission.DELETE_VIDEO
              ]
            }
          }
        },
        Treść: {
          Stopka: {
            route: "admin:footer",
            permissions: [Permission.CREATE_TEMPLATE]
          },
          "Polityka prywatności": {
            route: "admin:privacy",
            permissions: [Permission.CREATE_TEMPLATE]
          },
          "Informacja RODO": {
            route: "admin:gdpr",
            permissions: [Permission.CREATE_TEMPLATE]
          }
        },
        Administracja: {
          Diagnostyka: {
            route: "admin:diagnostics",
            permissions: [Permission.READ_DIAGNOSTICS]
          },
          Statystyki: {
            route: "admin:statistics",
            permissions: [Permission.READ_STATISTICS]
          },
          Zdarzenia: {
            route: "admin:events",
            permissions: [Permission.READ_STATISTICS]
          },
          Użytkownicy: {
            route: "admin:users",
            permissions: [Permission.READ_USERS]
          }
        }
      }
    };
  },

  computed: {
    computedMenu() {
      return parse(this.menu, o => this.hasPermissions(o));
    }
  },

  methods: {
    clickMenuItem(name) {
      this.$emit("go-to", name);
    },

    hasPermissions(object) {
      const required = get(object, "permissions");
      return required
        ? required.filter(i => this.$store.getters.permissions.includes(i))
            .length > 0
        : true;
    }
  }
};
</script>

<style lang="scss" scoped>
.is-header:hover {
  background: inherit;
  cursor: default;
}

.action a {
  padding-left: 2rem;
  padding-right: 2rem;
}
</style>
